import API_BASE_URL from "../../../../../Constants";

export const fetchBuildings = async (
  page,
  size,
  query,
  sortField,
  sortOrder
) => {
  const queryString = query ? `&q=${encodeURIComponent(query)}` : "";
  const sortString =
    sortField && sortOrder
      ? `&sortField=${encodeURIComponent(
          sortField
        )}&sortOrder=${encodeURIComponent(sortOrder)}`
      : "";
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/setup/buildings?page=${
        page - 1
      }&size=${size}${queryString}${sortString}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      }
    );
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Failed to fetch buildings:", error);
    throw error;
  }
};

export const fetchAllBuildings = async () => {
  const response = await fetch(`${API_BASE_URL}/api/setup/buildings/all`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  });
  if (!response.ok) {
    throw new Error(`Error: ${response.status}`);
  }
  return response.json();
};

export const fetchBuildingById = async (buildingId) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/setup/buildings/${buildingId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      }
    );

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const data = await response.json();
    return data; // This will include customer and management company objects if available
  } catch (error) {
    console.error(`Failed to fetch building with ID ${buildingId}:`, error);
    throw error;
  }
};
